// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_COMMENT = "P\u0159idej koment\u00e1\u0159";
export const BLOGS_POST_FORM_ONE_OF_COMMENT_PHOTO_OR_STICKER_IS_REQUIRED = "Pr\u00e1zdnou zpr\u00e1vu nem\u016f\u017ee\u0161 odeslat";
export const SEND_AS_ADMIN = "oznam MK";
export const SEND_COMMENT = "Ode\u0161li koment\u00e1\u0159";
